import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";

export const SearchBar = ({ initial = "", testId = "search" }) => {
  const [q, setQ] = useState(initial);
  const nav = useNavigate();
  return (
    <form
      onSubmit={(e) => { e.preventDefault(); nav(`/browse?q=${encodeURIComponent(q)}`); }}
      className="flex items-center gap-2 rounded-2xl bg-white p-1.5 pl-4 shadow-[0_10px_30px_-5px_rgba(0,0,0,0.3)]"
    >
      <Search className="h-5 w-5 shrink-0 text-slate-400" />
      <input data-testid={`${testId}-input`} value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search items, brands and categories" className="min-w-0 flex-1 bg-transparent py-2.5 text-[#0f2a33] outline-none placeholder:text-slate-400" />
      <button data-testid={`${testId}-submit-btn`} type="submit" className="rounded-xl bg-[#0f2a33] px-5 py-2.5 text-sm font-bold text-white transition-colors hover:bg-[#173742]">Search</button>
    </form>
  );
};
